export default __webpack_public_path__ + "static/media/wadex_art_platform_en_02.0be91791.png";